import { apiSlice } from "../api/apiSlice";

export const assignmentsApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAssignments: builder.query({
			query: () => "/assignments",
		}),
		addAssignment: builder.mutation({
			query: ({ data }) => ({
				url: "/assignments",
				method: "POST",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const assignment = await queryFulfilled;
					if (assignment?.data?.id) {
						// update tasks cache pessimistically start
						dispatch(
							apiSlice.util.updateQueryData(
								"getAssignments",
								undefined,
								(draft) => {
									// console.log(JSON.parse(JSON.stringify(draft)));
									draft.push(assignment.data)
								}
							)
						);
						// update tasks cache pessimistically end
					}
				} catch (err) { }
			},
		}),
		editAssignment: builder.mutation({
			query: ({ id, data }) => ({
				url: `/assignments/${id}`,
				method: "PATCH",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				// optimistic cache update start
				const pathResult = dispatch(
					apiSlice.util.updateQueryData(
						"getAssignments",
						undefined,
						(draft) => {
							const draftAssignment = draft.find((assignment) => assignment.id == arg.id);
							draftAssignment.title = arg.data.title;
							draftAssignment.video_id = arg.data.video_id;
							draftAssignment.video_title = arg.data.video_title;
							draftAssignment.totalMark = arg.data.totalMark;
						}
					)
				);
				// optimistic cache update end

				try {
					await queryFulfilled;
				} catch (err) {
					pathResult.undo();
				}
			},
		}),
		deleteAssignment: builder.mutation({
			query: ({ id }) => ({
				url: `/assignments/${id}`,
				method: "DELETE",
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				// optimistic cache update start
				const result = dispatch(
					apiSlice.util.updateQueryData(
						"getAssignments",
						undefined,
						(draft) => {
							return draft.filter((assignment) => assignment.id != arg.id);
						}
					)
				);
				// optimistic cache update end
				try {
					await queryFulfilled;
				} catch (err) {
					result.undo();
				}
			},
		}),
	}),
});

export const {
	useGetAssignmentsQuery,
	useAddAssignmentMutation,
	useEditAssignmentMutation,
	useDeleteAssignmentMutation
} = assignmentsApi;


